var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:('width:' + _vm.width),attrs:{"src":require('@/assets/pics/logo_white.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }